export enum USER_ROLE {
    admin = 'admin',
    user = 'user',
    minfin = 'minfin',
    operator = 'operator'
}


export const UserRoles = {
    [USER_ROLE.admin]: 'Администратор',
    [USER_ROLE.user]: 'Пользователь',
    [USER_ROLE.minfin]: 'Министерство финансов',
    [USER_ROLE.operator]: 'Оператор'
}